import apiBase from "./apiBase";

export default {
  getAssignedTestAttempts: async (serialNumber, examineeId) => {
    const url = `TestAttempts?kioskApiKey=${serialNumber}&examineeId=${examineeId}`;
    let response = await apiBase.callServiceSecure(
      url,
      null,
      apiBase.methodTypes.get
    );
    return response.data;
  },
  getSessionTestAttempts: async (testAttemptId) => {
    const url = `TestAttempts/SessionTestAttempts?testAttemptId=${testAttemptId}`;
    let response = await apiBase.callServiceSecure(
      url,
      null,
      apiBase.methodTypes.get
    );
    return response.data;
  },
  getTestAttemptDetails: async (testAttemptId, localeId) => {
    let response = await apiBase.callServiceSecure(
      `TestAttempts/Details?testAttemptId=${testAttemptId}&localeId=${localeId}`,
      null,
      apiBase.methodTypes.get
    );
    return response.data;
  },
  initializeTest: async (testAttemptId, serialNumber, localeId) => {
    let response = await apiBase.callServiceSecure(
      `Test/Initialize?testAttemptId=${testAttemptId}&serialNumber=${serialNumber}&localeId=${localeId}`,
      null,
      apiBase.methodTypes.get
    );
    return response.data;
  },
  getQuestion: async (testAttemptId, questionNumber, localeId) => {
    let response = await apiBase.callServiceSecure(
      `Test/Question?testAttemptId=${testAttemptId}&questionNumber=${questionNumber}&localeId=${localeId}`,
      null,
      apiBase.methodTypes.get
    );
    return response.data;
  },
  getSkippedQuestion: async (testAttemptId, questionNumber, localeId) => {
    let response = await apiBase.callServiceSecure(
      `Test/SkippedQuestion?testAttemptId=${testAttemptId}&questionNumber=${questionNumber}&localeId=${localeId}`,
      null,
      apiBase.methodTypes.get
    );

    return response.data;
  },
  saveAnswer: async (
    testAttemptId,
    questionNumber,
    answers,
    startTime,
    skippedQuestion
  ) => {
    const params = {
      testAttemptId: testAttemptId,
      questionNumber: questionNumber,
      answers: answers,
      startTime: startTime,
      skippedQuestion: skippedQuestion,
    };

    let response = await apiBase.callServiceSecure(
      "Test/SaveAnswer",
      params,
      apiBase.methodTypes.post
    );

    return response.data;
  },
  skipQuestion: async (testAttemptId, questionNumber) => {
    let response = await apiBase.callServiceSecure(
      `Test/SkipQuestion?testAttemptId=${testAttemptId}&questionNumber=${questionNumber}`,
      null,
      apiBase.methodTypes.post
    );
    return response.data;
  },
  completeTest: async (testAttemptId) => {
    let response = await apiBase.callServiceSecure(
      `Test/Complete?testAttemptId=${testAttemptId}`,
      null,
      apiBase.methodTypes.post
    );
    return response.data;
  },
  getTestQuestionSummary: async (testAttemptId, localeId) => {
    const url = `Test/QuestionSummary?testAttemptId=${testAttemptId}&localeId=${localeId}`;
    const response = await apiBase.callServiceSecure(
      url,
      null,
      apiBase.methodTypes.get
    );
    return response.data;
  },
  getTestAttemptStatus: async (testAttemptId) => {
    const url = `Test/TestAttemptStatus?testAttemptId=${testAttemptId}`;
    const response = await apiBase.callServiceSecure(
      url,
      null,
      apiBase.methodTypes.get
    );
    return response.data;
  },
};
